import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpHeaders,
  HttpResponse
} from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, map, switchMap, take, tap } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from './auth.service';
import { CommonService } from './common.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor(
    private commonService: CommonService,
    private authService: AuthService,
    private spinner: NgxSpinnerService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(request.url.startsWith("https://www.oasis.co.kr:9888")) {
      return next.handle(request.clone())
    }
    if(request.url.endsWith("refreshToken")) {
      return next.handle(request.clone())
    }
    if(request.url.startsWith("assets/terms")) {
      return next.handle(request.clone())
    }
    if(request.url.endsWith("login")) {
      return next.handle(request.clone())
    }
    let headers = this.commonService.getHeaders()
    return next.handle(request.clone({ headers : headers })).pipe(
      filter(event => event instanceof HttpResponse),
      map((event: HttpResponse<any>) => {
        if(event.body instanceof Blob) {
          //pass 
        } else {
          let resultCode = event.body.resultCode
          let message = event.body.message
          if (resultCode === '1001') {
            alert('사용 권한이 없습니다.')
            return false
          } else if (resultCode === '8888') {
            //내부에서 처리
          } else if (resultCode !== '0000') {
            this.spinner.hide()
            alert(message)
            return false
          } 
        }
        return event
      }),
      catchError((error: HttpErrorResponse, caught: Observable<any>) => {
        if (error.status === 0) {
           alert('API서버와 연결 할 수 없습니다.\n잠시 후 다시 부탁드립니다.\n계속 발생 시 담당자에게 문의바랍니다.');
        } else if (error.status === 401) {   
          return this.handle401Error(request, next);
        } else if (error.status === 403) {   
          alert('권한 없음');
        } else { 
          console.log(error)
          alert('오류가 발생했습니다.');
        }
        this.spinner.hide()
        return throwError(error)
      })
    );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) : any {
    this.spinner.hide()
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      const token = this.commonService.getUserInfo().refreshToken
      if (token) {
        return this.authService.refreshToken().pipe(
          switchMap((token: any) => {
            this.isRefreshing = false;
            this.authService.saveToken(token.accessToken, token.refreshToken)
            this.refreshTokenSubject.next(token.accessToken);
            let headers = new HttpHeaders({
              "Authorization" : "Bearer " + token.accessToken
            })
            return next.handle(request.clone({ headers : headers }));
          }),
          catchError((error: HttpErrorResponse, caught: Observable<any>) => {
            this.isRefreshing = false;
            alert('만료된 토큰입니다.\n재로그인 후 이용하세요');
            this.authService.logout()
            return throwError("")
          })
        );
      }
    }  
    return this.refreshTokenSubject.pipe(
      filter(token => token !== null),
      take(1),
      switchMap((token) => next.handle(request.clone({ headers : this.commonService.getHeaders() })))
    );
  }  
}
